import { useState, useEffect } from 'react';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _IndirectCostType, _LabourType } from '../../../core/services/dataBean/EntityCatalog';
import { BasicTable, MASK_NUMBER } from '../../theme/Component/BasicTable';
import { Modal } from '../../theme/Component/Modal';
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from '../../theme/Component/hooks/useModal';
import { _ProductionResource } from '../../../core/services/dataBean/EntityCatalogVdos';
import usePaginator from '../../theme/Component/usePaginator';
import { SelectCostConstants } from './SelectCostConstants';
import { BasicButton } from '../../theme/Component/BasicButton';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    typereturn?: any;
    returnType?: "ID" | "Object";
    render?: string;
}

export const SelectIndirectConstTypeEditor = ({ idSelector, onChange, label, returnType = "ID", render, typereturn }: Props) => {

    const { instance, lista, setLista } = useDataBean(_IndirectCostType)
    const [id, setID] = useState(null);
    const paginador = usePaginator();
    const [type, settype] = useState<any>(typereturn);
    const [regexStr, setregexStr] = useState<string>(null)
    const modal = useModal("Tipos de Costos", MODAL_LG);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    // useEffect(() => {
    //     getLista();
    // }, [paginador.page])
    useEffect(() => {
        getLista();
    }, [paginador.page])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDIndirectCostType == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    // const getLista = () => {

    //     instance.getIndirectCostTypeCatalog(null).then(
    //         (resp: any) => {
    //             if (resp) {
    //                 setLista(resp)
    //             }
    //         }
    //     ).catch(err => { console.log(err) })
    // }

    const getLista = () => {
        instance.getIndirectCostTypeCatalogvdos(null, type, regexStr, paginador.page, 15).then(
            (resp: any) => {
                //console.log(resp.NumberOfPages)
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15)

                setLista(resp.List)
            }
        ).catch(
            err => { console.log(err) }
        )
    }
    const head = [
        { title: 'ID', property: 'IDIndirectCostType', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Tipo Costo', property: 'TypeName', visible: true },
        { title: 'Cuenta Contable WIP', property: 'WIPAccountantIDStrName', visible: true },
        { title: 'Cuenta Contable Costo', property: 'AccountantIDStrName', visible: true },
        { title: 'Empleado', property: 'EmployeeName', visible: true },

    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Tipos de Costos Indirectos"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-4">
                        <SelectCostConstants disabled={!!typereturn} idSelector={type} onChange={(e) => { settype(e) }} />
                    </div>
                    <div className="col-md-4">
                        <label>Búsqueda por Texto</label>
                        <input type="text" name="Name" className="form-control" value={regexStr} onChange={(e: any) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-4 mt-4 p-2">
                        <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                            Buscar
                        </BasicButton>
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDIndirectCostType); modal.close(); }} pageTop={paginador.page}
                    next={paginador.next}
                    back={paginador.back}
                    records={paginador}
                    customRows={15}></BasicTable>
            </Modal>
        </>
    )
}